module.exports = __webpack_public_path__ + "img/energetic.cb82c901.gif";